var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  页面不存在或没有权限，请联系管理员"),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.logout}},[_vm._v("退出登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }